<template>
  <div>
    <Header></Header>
    <div class="bg-000">
      <div class="container">
        <div class="row">
          <div
            class="col-lg-9 col-md-9 col-sm-8 col-xs-12 text-white p-0"  style="
            border-top: #000 12px solid;
          "
            
            ref="init"
          >
            <iframe
              id="video"
              src="https://2d.hep.com.cn/iframe/PK3FXWZP6"
              frameborder="no"
              border="0"
              marginwidth="0"
              marginheight="0"
              scrolling="no"
              allowTransparency="true"
              allowfullscreen="allowfullscreen"
              data-mce-fragment="1"
              width="720px"
              height="405px"
            ></iframe>
          </div>
          <div
            class="col-lg-3 col-md-3 col-sm-4 col-xs-12 bg-dark text-white pt-3  pr-0"
          >
            <h5>{{ book.title }}</h5>
            <ul class="list-unstyled" style="height:542px;overflow-y:auto;">
              <li
                class="text-secondary pt-1 pb-1"
                v-for="item in resource"
                :key="item._id"
                @click="handleClick(item._id, item.price, item.absoluteURL)"
              >
                <a
                  href="#"
                  :class="item._id === current ? 'text-white' : 'text-white-50'"
                  ><svg
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="css-i6dzq1 mr-1"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <polygon points="10 8 16 12 10 16 10 8"></polygon></svg
                  >{{ item.title }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import { getResources, getBookDetail, isBuy } from "../api";
import Header from "../components/header";
import Bottom from "../components/bottom";
export default {
  data() {
    return {
      book: {},
      resource: [],
      current: "",
      isBuyRes: false,
    };
  },
  components: {
    Header,
    Bottom,
  },
  created() {
    if (this.$route.params.ID) {
      // console.log(this.$route.params.ID);
      getBookDetail(this.$route.params.ID).then((data) => {
        this.book = data.data;
      });
      
      getResources(this.$route.params.ID, { chapter: "06", sort: "seq" }).then(
        (data) => {
          this.resource = data.rows;
          this.current = data.rows[0]._id;
          if(data.rows[0].price > 0){
            isBuy(this.book._id,this.current).then(
                (data) => {
                  console.log(data);
                    if(data.success){
                        document.getElementById("video").src =
                        "https://2d.hep.com.cn/iframe/" + this.current;
                    }else{
                      alert("未购买资源，请登录购买后查看！");
                      window.location.href = data.rows[0].absoluteURL;
                    }
                }
              );
          }else{
              document.getElementById("video").src = "https://2d.hep.com.cn/iframe/" + this.current;
          }
          
        }
      );
    }
  },
  mounted() {
    let w = this.$refs.init.clientWidth;
    document.getElementById("video").width = w;
    document.getElementById("video").height = 0.5625 * w;
  },
  methods: {
    handleClick(id,price,url) {

      this.current = id;
      console.log(price);
      if(price > 0){
        isBuy(this.book._id,this.current).then(
            (data) => {
              console.log(data);
                if(data.success){
                    document.getElementById("video").src =
                    "https://2d.hep.com.cn/iframe/" + this.current;
                }else{
                  alert("未购买资源，请登录购买后查看！");
                  window.location.href = url;
                }
            }
          );
      }else{
          document.getElementById("video").src = "https://2d.hep.com.cn/iframe/" + id;
      }
      
    },
  },
};
</script>

<style type="text/css">	
  body{
    background:#f6f7fa;
    padding-bottom:75px;
  }
  ::-webkit-scrollbar  
  {  
    width: 10px;    
    background-color: #343a40;  
  }   
  ::-webkit-scrollbar-track  
  {  
    -webkit-box-shadow: none;  
    border-radius: 10px;  
    background-color: #343a40;  
  }  
 
  ::-webkit-scrollbar-thumb  
  {  
    border-radius: 10px;  
    -webkit-box-shadow:none;  
    background-color: #4e5a5e;  
  }  
  ::-webkit-scrollbar-button{
    background-color: #343a40;
    border:none;
  }
  .footer{
    position:fixed;
    width:100%;
    bottom:0;
  }

</style>
